import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './HardwareList.cssmodule.less';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import { clickButton } from '../../actions/Modal';
import { HardwareModalMode } from '@/Constants';

class HardwareList extends BaseComponent {
    constructor(props) {
        super(props);
        this.Style = Style;
        const { item = {} } = props;
        const { content = [], mode = 'VIEWER' } = item;
        this.mode = mode;
        this.state = {
            hardwareList: content,
        };
    }

    setHardwareList(filter) {
        const { item = {} } = this.props;
        const { content = [] } = item;
        let hardwareList = content;
        if (filter) {
            hardwareList = _.filter(content, (item) => {
                return item.nameByLang.indexOf(filter) > -1;
            });
        }
        this.setState({
            hardwareList,
        });
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    handleItemClick(index) {
        const { clickButton } = this.props.actions;
        const { hardwareList = [] } = this.state;
        const item = hardwareList[index];

        if (this.mode === HardwareModalMode.VIEWER && item.url) {
            window.open(item.url);
            clickButton({
                event: 'close',
            });
        } else if (this.mode === HardwareModalMode.SELECT) {
            clickButton({
                event: item,
            });
        }
    }

    handleRemoveText = () => {
        const { inputText } = this.refs;
        inputText.value = '';
        inputText.focus();
        this.activateRemoveButton(null);
        this.setHardwareList(null);
    };

    handleChange = (e) => {
        const { target = {} } = e;
        const { value } = target;
        this.activateRemoveButton(value);
    };

    handleKeyUp = (e) => {
        if (e.keyCode === 13) {
            const { target = '' } = e;
            const { value } = target;
            this.setHardwareList(value);
        } else if (e.keyCode === 27) {
            this.handleRemoveText();
        }
    };

    handleSearchClick = (e) => {
        const { inputText } = this.refs;
        const { value } = inputText;
        this.setHardwareList(value);
    };

    activateRemoveButton(text) {
        this.setState({
            isActiveRemove: text && text.length,
        });
    }

    makeContent() {
        const content = [];
        const { hardwareList } = this.state;
        const listCount = hardwareList.length;
        let row = [];

        for (let i = 0; i < listCount; i += 4) {
            for (let index = i; index < i + 4; index++) {
                const item = hardwareList[index];
                if (!item) {
                    break;
                }
                row.push(
                    <div key={item.name} className={this.Style.listCell}>
                        <div
                            className={this.Style.hardwareItem}
                            onClick={() => this.handleItemClick(index)}
                        >
                            <img
                                src={`/lib/entry-js/images/hardware/${
                                    item.imageName || `${item.name}.png`
                                }`}
                                className={this.Style.image}
                            />
                            <div>{item.nameByLang}</div>
                        </div>
                    </div>
                );
            }
            content.push(
                <div key={i} className={this.Style.listRow}>
                    {row}
                </div>
            );
            row = [];
        }
        return <div className={this.Style.listTable}>{content}</div>;
    }

    render() {
        const { item = {} } = this.props;
        const { className, title = '' } = item;
        const isSearchMode = this.mode === HardwareModalMode.SELECT;
        const { isActiveRemove = false } = this.state;
        const isActive = isActiveRemove ? this.Style.active : '';

        return (
            <div
                className={`${this.Style.HardwareList} ${
                    this.Style[className]
                }`}
            >
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    <div className={this.Style.text}>{title}</div>
                    {isSearchMode && (
                        <div className={this.Style.searchArea}>
                            <input
                                type="text"
                                onChange={this.handleChange}
                                ref="inputText"
                                onKeyUp={this.handleKeyUp}
                            />
                            <div
                                onClick={this.handleRemoveText}
                                className={`${this.Style.remove} ${isActive}`}
                            >
                                <div />
                                <div />
                            </div>
                            <div
                                className={this.Style.searchIcon}
                                onClick={this.handleSearchClick}
                            />
                        </div>
                    )}
                </Title>
                <div className={this.Style.contentView}>
                    <div className={this.Style.content}>
                        {this.makeContent()}
                    </div>
                </div>
            </div>
        );
    }
}

HardwareList.displayName = 'HardwareList';
HardwareList.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(HardwareList);



// WEBPACK FOOTER //
// ./components/ModalSet/HardwareList.js